import { AusActions } from "@aus/Store/AusState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{}, DispatchProp<AusActions>>;

export const ToggleOrdersFilter: HandlerType = props => {
    props.dispatch({
        type: "Pages/WorkOrderHistory/ToggleFiltersOpen",
    });
};

export const chain = [ToggleOrdersFilter];

const toggleFiltersOpen = createHandlerChainRunnerOptionalParameter(chain, {}, "ToggleFiltersOpen");
export default toggleFiltersOpen;
